"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeaderButtonContent = exports.TableHeaderButtonBase = exports.TableContainerHorizontal = exports.DisabledActionButton = exports.Caption = exports.ActionCellTh = exports.ActionCellTd = exports.ActionButtonWrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isPropValid = _interopRequireDefault(require("@emotion/is-prop-valid"));

var _button = require("../../button");

var _context = require("../../context");

var _layout = require("../../layout");

var _utils = require("../../utils");

var _Th = _interopRequireDefault(require("../html/Th"));

var _constants = require("../html/constants");

var _html = require("../html");

var _interfaces = require("../interfaces");

var _TableContainer = _interopRequireDefault(require("./TableContainer"));

var _constants2 = require("./constants");

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TableContainerHorizontal = (0, _context.styledWithTheme)(_TableContainer.default)(function (_ref) {
  var isFocusedByTab = _ref.isFocusedByTab,
      selectors = _ref.theme.selectors;
  var NEUTRAL0 = selectors.color('neutral0');
  var NEUTRAL05 = selectors.color('neutral05');
  var backgroundGradient = "\n    linear-gradient(to right, ".concat(NEUTRAL0, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to right, ").concat(NEUTRAL0, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to right, ").concat(NEUTRAL05, ", ").concat(NEUTRAL0, "),\n    linear-gradient(to left, ").concat(NEUTRAL05, ", ").concat(NEUTRAL0, ")\n  ");
  return _objectSpread({
    backgroundImage: backgroundGradient,
    backgroundPosition: 'left center, right center, left center, right center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: NEUTRAL0,
    backgroundSize: '32px 100%, 32px 100%, 22px 100%, 22px 100%',
    backgroundAttachment: 'local, local, scroll, scroll',
    outline: 'none'
  }, isFocusedByTab && {
    ':focus': {
      boxShadow: "0 0 0pt 2px ".concat(selectors.color('primary80'))
    }
  });
});
exports.TableContainerHorizontal = TableContainerHorizontal;
var ActionCellTh = (0, _context.styledWithTheme)(_Th.default, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return (0, _utils.filterProps)(['width'])(prop) && (0, _isPropValid.default)(prop);
  }
})(function (_ref2) {
  var selectors = _ref2.theme.selectors,
      width = _ref2.width;
  return {
    width: width !== null && width !== void 0 ? width : (0, _utils.px)(_constants2.ACTION_BUTTON_WIDTH + 2 * selectors.space(_constants.CELL_SPACING_HORIZONTAL))
  };
});
exports.ActionCellTh = ActionCellTh;
var ActionCellTd = ActionCellTh.withComponent(_html.TdElement, {
  target: "e1o800b60"
});
exports.ActionCellTd = ActionCellTd;
var DisabledActionButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    ':focus': {
      borderColor: selectors.color('neutral70')
    },
    ':hover': {
      borderColor: selectors.color('neutral70')
    }
  };
});
exports.DisabledActionButton = DisabledActionButton;
var TableHeaderButtonContent = (0, _context.styledWithTheme)(_layout.Row)(function (_ref4) {
  var spacing = _ref4.spacing,
      textAlign = _ref4.textAlign,
      selectors = _ref4.theme.selectors;
  var paddingHorizontal = (0, _utils.px)(selectors.space(_constants.CELL_SPACING_HORIZONTAL));
  var paddingVertical = (0, _utils.px)(selectors.space(spacing === _interfaces.TableSpacing.Reduced ? _constants.HEADER_SPACING_VERTICAL_REDUCED : _constants.HEADER_SPACING_VERTICAL));
  return {
    padding: "".concat(paddingVertical, " ").concat(paddingHorizontal),
    textAlign: textAlign
  };
});
exports.TableHeaderButtonContent = TableHeaderButtonContent;
var TableHeaderButtonBase = (0, _context.styledWithTheme)('button')(function (_ref5) {
  var isFocusedByTab = _ref5.isFocusedByTab,
      selectors = _ref5.theme.selectors;
  var outlineWidth = (0, _utils.px)(_constants2.TABLE_HEADER_BUTTON_BORDER_WIDTH);
  var outlineHoverColor = selectors.color(_constants2.TABLE_HEADER_BUTTON_BORDER_COLOR);
  var outlineFocusColor = selectors.color(_constants2.TABLE_HEADER_BUTTON_FOCUS_BORDER_COLOR);
  var borderRadius = selectors.radius('R200');
  return _objectSpread({
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    boxSizing: 'border-box',
    color: selectors.color('neutral90'),
    cursor: 'pointer',
    fontFamily: selectors.fontFamily('primary'),
    fontSize: (0, _utils.px)(selectors.fontSize('T200')),
    fontWeight: selectors.fontWeight('regular'),
    justifyContent: 'center',
    lineHeight: 'inherit',
    outline: 'none',
    textAlign: 'center',
    transition: 'box-shadow .2s, border-color .2s',
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    borderRadius: borderRadius,
    ':hover': {
      outline: "".concat(outlineWidth, " solid ").concat(outlineHoverColor),
      outlineOffset: "-".concat((0, _utils.px)(_constants2.TABLE_HEADER_BUTTON_BORDER_WIDTH))
    }
  }, isFocusedByTab && {
    ':focus': {
      outline: "".concat(outlineWidth, " solid ").concat(outlineFocusColor),
      outlineOffset: "-".concat((0, _utils.px)(_constants2.TABLE_HEADER_BUTTON_BORDER_WIDTH - 1))
    }
  });
});
exports.TableHeaderButtonBase = TableHeaderButtonBase;
var Caption = (0, _context.styledWithTheme)('caption', {
  shouldForwardProp: (0, _utils.filterProps)(['fontSize', 'paddingBottom', 'color', 'fontWeight', 'captionText'])
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n", ""])), function (_ref6) {
  var fontSize = _ref6.fontSize,
      paddingBottom = _ref6.paddingBottom,
      color = _ref6.color,
      fontWeight = _ref6.fontWeight,
      theme = _ref6.theme;
  return "\n  caption-side:".concat(_constants2.TABLE_CAPTION_SIDE, ";\n  text-align:").concat(_constants2.TABLE_CAPTION_TEXT_ALIGN, ";\n  font-size:").concat(theme.selectors.fontSize(fontSize), ";\n  padding-bottom: ").concat((0, _utils.px)(theme.selectors.space(paddingBottom)), ";\n  color: ").concat(theme.selectors.colorOrNull(color), ";\n  font-weight: ").concat(theme.selectors.fontWeight(fontWeight), ";\n");
});
exports.Caption = Caption;
var ActionButtonWrapper = (0, _context.styledWithTheme)('div')({
  display: 'inline-block'
});
exports.ActionButtonWrapper = ActionButtonWrapper;